webpackJsonp([71],{

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);



var downloadCardTravel = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, typeDocumentCode, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						typeDocumentCode = 'registerCard';
						name = 'TARJETA-DE-EMBARQUE' + this.bookingCode;
						responseType = 'blob';
						cardModel = { details: [{}] };
						_context.next = 7;
						return this.$http.post(baseUrl + '/booking/' + this.bookingCode + '/report/' + typeDocumentCode, cardModel, { responseType: responseType });

					case 7:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function downloadCardTravel() {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref3, booking, responseData, numTotal, defaultLang;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings/' + this.$route.query.codeBooking);

					case 2:
						_ref3 = _context2.sent;
						booking = _ref3.data;
						responseData = booking.data;
						numTotal = responseData.femaleNum ? Number(responseData.femaleNum) : 0;

						responseData.guests = numTotal + responseData.maleNum ? Number(responseData.maleNum) : 0;
						defaultLang = responseData.summary.language;

						responseData.employee.data = responseData.employee.data ? responseData.employee.data : {};
						responseData.channel = responseData.channel ? responseData.channel : {};
						responseData.channel.data = responseData.channel.data ? responseData.channel.data : {};
						responseData.channel.data.questions = responseData.channel.data.questions ? responseData.channel.data : {};
						responseData.summary.personalInformation.payment = responseData.summary.personalInformation.payment ? responseData.summary.personalInformation.payment : {};
						responseData.summary.promotion.name = responseData.summary.promotion[defaultLang] ? responseData.summary.promotion[defaultLang].name : responseData.summary.promotion.name;
						this.booking = responseData;

					case 15:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

var loadStates = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref5, states;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/booking/status');

					case 2:
						_ref5 = _context3.sent;
						states = _ref5.data;

						this.states = states.data;

					case 5:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadStates() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var helperMethods = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].methods;

function created() {
	this.loadStates();
	this.loadData();
}

function bookingStateName() {
	var stateNumber = Number(this.booking.bookingState);
	var returnState = this.states.find(function (state) {
		return state.id === stateNumber;
	}) || {};
	return returnState.name;
}

function print() {
	window.print();
}

function data() {
	return {
		booking: {
			channel: {
				data: {
					questions: {}
				}
			},
			employee: {
				data: {}
			},
			summary: {
				booking: {},
				personalInformation: {
					payment: {}
				},
				promotion: {},
				ratesPerDates: []
			}
		},
		columns: [{ id: 1, name: 'Habitación' }, { id: 2, name: '# Huéspedes' }, { id: 3, name: 'Adultos' }, { id: 4, name: 'Niños' }, { id: 5, name: 'Fecha de llegada' }, { id: 6, name: 'Fecha de Partida' }, { id: 7, name: 'Estado' }, { id: 8, name: 'Precio' }],
		model: {
			cardholder: '',
			cardNumber: '',
			cardType: '',
			comment: '',
			email: '',
			lastname: '',
			name: '',
			phone: ''
		},
		states: []
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'detail-guest',
	created: created,
	computed: {
		bookingStateName: bookingStateName
	},
	data: data,
	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_2__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_2__shared_filters__["c" /* round */]
	},
	methods: {
		downloadCardTravel: downloadCardTravel,
		loadData: loadData,
		loadStates: loadStates,
		print: print
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".card-detail[data-v-3249e3f4]{background-color:#fff;min-height:275px}.card-detail-label[data-v-3249e3f4]{color:#2f302f;font-family:San Francisco Display Medium;font-size:14px;font-weight:400}.card-detail-name[data-v-3249e3f4]{color:#2f302f;font-family:San Francisco Display;font-size:30px;font-weight:400;line-height:normal;margin-bottom:0}.card-detail-comment[data-v-3249e3f4]{color:#818181;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-style:oblique;line-height:0}.card-detail-hr[data-v-3249e3f4]{background-color:#b7b7b7;height:2px}.card-detail-footer label[data-v-3249e3f4]{color:#2f302f;font-family:San Francisco Display Medium;font-size:16px;font-weight:400}.card-detail-footer span[data-v-3249e3f4]{color:#2f302f;font-family:San Francisco Display;font-size:14px;font-weight:400}.card-detail-total[data-v-3249e3f4]{background-color:#2f302f;color:#fff}.card-detail-total label[data-v-3249e3f4]{font-family:San Francisco Display Semi Bold;font-size:14px;font-weight:400}.card-detail-table th[data-v-3249e3f4]{background-color:#545e72;color:#fff;font-weight:400;height:42px;padding:0 0 0 21px;text-align:left}.card-detail-table td[data-v-3249e3f4]{background-color:#fff;border-bottom:1px solid #e0e0e0;color:#545e72;font-family:San Francisco Display Medium;font-size:14px;max-width:188px;padding:14px 0 14px 21px;text-align:left}.card-detail-table.card-footer-table td[data-v-3249e3f4]{border-bottom:0;max-width:none;padding:9px 0 9px 21px}.card-detail-table.card-footer-table td[data-v-3249e3f4]:first-child{width:290px}.card-detail-table.card-footer-table td[data-v-3249e3f4]:last-child{color:#818181;font-family:San Francisco Display;font-size:14px}.card-detail-info[data-v-3249e3f4]{background-color:#fff;padding:16px 21px 26px!important}.card-detail-info label[data-v-3249e3f4]{color:#545e72;font-family:San Francisco Display Medium;font-size:14px}.card-detail-info span[data-v-3249e3f4]{color:#818181;font-family:San Francisco Display;font-size:14px}.card-detail-rates label[data-v-3249e3f4]{color:#2f302f;font-family:San Francisco Display Medium;font-size:14px}.card-detail-rates table th[data-v-3249e3f4]{background-color:#7f7f7f;color:#fff;font-weight:400;height:30.5px;padding:0 0 0 16px;text-align:left}.card-detail-rates table td[data-v-3249e3f4]{color:#818181;font-family:San Francisco Display;font-size:14px;padding:6px 0 6px 16px;text-align:left}.default-height[data-v-3249e3f4]{height:63px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/guest/detail-guest.vue"],"names":[],"mappings":"AACA,8BACE,sBAAwB,AACxB,gBAAkB,CACnB,AACD,oCACI,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAoB,CACvB,AACD,mCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,gBAAoB,AACpB,mBAAoB,AACpB,eAAmB,CACtB,AACD,sCACI,cAAe,AACf,uCAA0C,AAC1C,eAAgB,AAChB,mBAAoB,AACpB,aAAe,CAClB,AACD,iCACI,yBAA0B,AAC1B,UAAY,CACf,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAoB,CACvB,AACD,0CACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,eAAoB,CACvB,AACD,oCACI,yBAA0B,AAC1B,UAAa,CAChB,AACD,0CACM,4CAA+C,AAC/C,eAAgB,AAChB,eAAoB,CACzB,AACD,uCACI,yBAA0B,AAC1B,WAAa,AACb,gBAAoB,AACpB,YAAa,AACb,mBAA0B,AAC1B,eAAiB,CACpB,AACD,uCACI,sBAAwB,AACxB,gCAAiC,AACjC,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,gBAAiB,AACjB,yBAA4B,AAC5B,eAAiB,CACpB,AACD,yDACI,gBAAmB,AACnB,eAAgB,AAChB,sBAA0B,CAC7B,AACD,qEACM,WAAa,CAClB,AACD,oEACM,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACrB,AACD,mCACI,sBAAwB,AACxB,gCAAmC,CACtC,AACD,yCACM,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACrB,AACD,wCACM,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACrB,AACD,0CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,6CACI,yBAA0B,AAC1B,WAAa,AACb,gBAAoB,AACpB,cAAe,AACf,mBAA0B,AAC1B,eAAiB,CACpB,AACD,6CACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,uBAA0B,AAC1B,eAAiB,CACpB,AACD,iCACE,WAAa,CACd","file":"detail-guest.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.card-detail[data-v-3249e3f4] {\n  background-color: white;\n  min-height: 275px;\n}\n.card-detail-label[data-v-3249e3f4] {\n    color: #2f302f;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 14px;\n    font-weight: normal;\n}\n.card-detail-name[data-v-3249e3f4] {\n    color: #2f302f;\n    font-family: \"San Francisco Display\";\n    font-size: 30px;\n    font-weight: normal;\n    line-height: normal;\n    margin-bottom: 0px;\n}\n.card-detail-comment[data-v-3249e3f4] {\n    color: #818181;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 12px;\n    font-style: oblique;\n    line-height: 0;\n}\n.card-detail-hr[data-v-3249e3f4] {\n    background-color: #b7b7b7;\n    height: 2px;\n}\n.card-detail-footer label[data-v-3249e3f4] {\n    color: #2f302f;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 16px;\n    font-weight: normal;\n}\n.card-detail-footer span[data-v-3249e3f4] {\n    color: #2f302f;\n    font-family: \"San Francisco Display\";\n    font-size: 14px;\n    font-weight: normal;\n}\n.card-detail-total[data-v-3249e3f4] {\n    background-color: #2f302f;\n    color: white;\n}\n.card-detail-total label[data-v-3249e3f4] {\n      font-family: \"San Francisco Display Semi Bold\";\n      font-size: 14px;\n      font-weight: normal;\n}\n.card-detail-table th[data-v-3249e3f4] {\n    background-color: #545e72;\n    color: white;\n    font-weight: normal;\n    height: 42px;\n    padding: 0px 0px 0px 21px;\n    text-align: left;\n}\n.card-detail-table td[data-v-3249e3f4] {\n    background-color: white;\n    border-bottom: 1px solid #e0e0e0;\n    color: #545e72;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 14px;\n    max-width: 188px;\n    padding: 14px 0px 14px 21px;\n    text-align: left;\n}\n.card-detail-table.card-footer-table td[data-v-3249e3f4] {\n    border-bottom: 0px;\n    max-width: none;\n    padding: 9px 0px 9px 21px;\n}\n.card-detail-table.card-footer-table td[data-v-3249e3f4]:first-child {\n      width: 290px;\n}\n.card-detail-table.card-footer-table td[data-v-3249e3f4]:last-child {\n      color: #818181;\n      font-family: \"San Francisco Display\";\n      font-size: 14px;\n}\n.card-detail-info[data-v-3249e3f4] {\n    background-color: white;\n    padding: 16px 21px 26px !important;\n}\n.card-detail-info label[data-v-3249e3f4] {\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n}\n.card-detail-info span[data-v-3249e3f4] {\n      color: #818181;\n      font-family: \"San Francisco Display\";\n      font-size: 14px;\n}\n.card-detail-rates label[data-v-3249e3f4] {\n    color: #2f302f;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 14px;\n}\n.card-detail-rates table th[data-v-3249e3f4] {\n    background-color: #7f7f7f;\n    color: white;\n    font-weight: normal;\n    height: 30.5px;\n    padding: 0px 0px 0px 16px;\n    text-align: left;\n}\n.card-detail-rates table td[data-v-3249e3f4] {\n    color: #818181;\n    font-family: \"San Francisco Display\";\n    font-size: 14px;\n    padding: 6px 0px 6px 16px;\n    text-align: left;\n}\n.default-height[data-v-3249e3f4] {\n  height: 63px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("68bc9d46", content, true);

/***/ }),

/***/ 1614:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "print-no-show",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar tarjeta de embarque'
      }),
      expression: "{ html: 'Descargar tarjeta de embarque' }",
      arg: "left"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadCardTravel
    }
  }, [_c('v-icon', [_vm._v("card_travel")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Imprimir detalle de reserva'
      }),
      expression: "{ html: 'Imprimir detalle de reserva' }",
      arg: "left"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "text-xs-left": "",
      "pr-4": ""
    }
  }, [_c('v-layout', {
    staticClass: "card-detail",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.hotelName) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "px-3": ""
    }
  }, [_c('h3', {
    staticClass: "card-detail-name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.name) + "\n\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.lastName) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "default-height",
    attrs: {
      "xs12": "",
      "pl-3": "",
      "pr-4": "",
      "py-0": ""
    }
  }, [(_vm.booking.summary.personalInformation.specialRequest) ? _c('span', {
    staticClass: "card-detail-comment"
  }, [_vm._v("\n\t\t\t\t\t\t\"" + _vm._s(_vm.booking.summary.personalInformation.specialRequest) + "\"\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-divider', {
    staticClass: "card-detail-hr"
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-footer",
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Email:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.email))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Teléfono:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v("+" + _vm._s(_vm.booking.summary.personalInformation.phone))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    staticClass: "card-detail",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-5": "",
      "pt-3": "",
      "pb-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNúmero de Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.numReservation))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tReserve Number GDS:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.code))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEstado de la Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.bookingStateName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSitio web:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v("Sitio Web")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFecha de Reserva:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingDate, 'DD/MM/YYYY HH:mm:ss')) + " (Extranet TimeZone)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pb-0": ""
    }
  }, [_c('label', {
    staticClass: "card-detail-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tÚltima actualización:\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pb-0": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.updatedAt, 'DD/MM/YYYY HH:mm:ss')) + " (Hotel TimeZone)")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-total",
    attrs: {
      "xs12": "",
      "px-5": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "py-2": ""
    }
  }, [_c('label', [_vm._v("Venta Mensual")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "py-2": "",
      "text-xs-right": ""
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.total)) + " " + _vm._s(_vm.booking.summary.promotion.iso_currency))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('table', {
    staticClass: "card-detail-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column) {
    return _c('th', {
      key: column.id
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(column.name) + "\n\t\t\t\t\t\t")])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.roomName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.guests))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.booking.adults))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.booking.childrens))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.summary.booking.checkIn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.summary.booking.checkOut)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.stateName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.total)) + " " + _vm._s(_vm.booking.summary.promotion.iso_currency))])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "card-detail-info",
    attrs: {
      "xs12": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Observaciones:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "pr-2": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.booking.observations))])])], 1), _vm._v(" "), (_vm.booking.summary.services) ? _c('v-layout', {
    staticClass: "card-detail-rates",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Servicios adicionales:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "mb-3": ""
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th', [_vm._v("Precio")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.booking.summary.services), function(service) {
    return _c('tr', {
      key: service.id
    }, [_c('td', [_vm._v(_vm._s(service.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(service.total)) + " " + _vm._s(service.iso_currency))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.earlyCheckIn.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.earlyCheckIn.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.summary.earlyCheckIn.total)) + " " + _vm._s(_vm.booking.summary.earlyCheckIn.iso_currency))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.booking.summary.lateCheckOut.languages.es.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.lateCheckOut.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(_vm.booking.summary.lateCheckOut.total)) + " " + _vm._s(_vm.booking.summary.lateCheckOut.iso_currency))])])], 2)])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "card-detail-rates",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "text-xs-left": ""
    }
  }, [_c('label', [_vm._v("Tarifas:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": ""
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Habitación:")]), _vm._v(" "), _c('th', [_vm._v("Tarifa")]), _vm._v(" "), _c('th', [_vm._v("Día")]), _vm._v(" "), _c('th', [_vm._v("Precio")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.booking.summary.ratesPerDates), function(rate) {
    return _c('tr', {
      key: rate.id
    }, [_c('td', [_vm._v(_vm._s(_vm.booking.summary.promotion.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(rate.date_reservation)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(rate.price)) + " " + _vm._s(rate.iso_currency))]), _vm._v(" "), _c('td')])
  }))])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('table', {
    staticClass: "card-detail-table card-footer-table",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Datos de la tarjeta")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Nombre del titular de la tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.name) + "\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.personalInformation.lastName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Número de la tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.cardNumber))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tipo de tarjeta:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.cardType))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fecha de expiración:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.booking.summary.personalInformation.payment.month) + " / " + _vm._s(_vm.booking.summary.personalInformation.payment.year))])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1475)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1283),
  /* template */
  __webpack_require__(1614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3249e3f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/71.55ca30d586289494abd4.js